"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVerifyCookies = exports.LanguageSwitcherPopup = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../components");
var _constantsGenerated = require("../constants-generated");
var _contexts = require("../contexts");
var _useTenantLanguages = require("../hooks/useTenantLanguages");
var _logger2 = require("../logger");
var _utils = require("../utils");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Ensures that language cookie is set when there is language in URL
 */
const useVerifyCookies = (currentLanguage, tenant, languages) => (0, _react.useEffect)(() => {
  const currentLanguageInfo = languages?.find(({
    code
  }) => currentLanguage === code);
  if (languages && currentLanguageInfo && (0, _utils.hasLanguageInUrl)(languages) && !(0, _utils.getLanguageCookieValue)()) {
    (0, _utils.changeLanguage)(currentLanguageInfo, currentLanguage, tenant, false);
  }
}, [languages, currentLanguage, tenant]);

/**
 * Language switcher modal component that shows and changes language
 */
exports.useVerifyCookies = useVerifyCookies;
const LanguageSwitcherPopup = props => {
  const {
    prefetchedLanguages,
    currentLanguage,
    tenant,
    staticApiUrl
  } = props;
  const {
    data: fetchedLanguages
  } = (0, _useTenantLanguages.useTenantLanguages)(staticApiUrl, tenant, !!prefetchedLanguages);
  const availableLanguages = (0, _react.useMemo)(() => prefetchedLanguages ?? fetchedLanguages, [fetchedLanguages, prefetchedLanguages]);
  const [modalIsOpen, setModalIsOpen] = (0, _react.useState)((0, _utils.getDefaultIsOpenedState)(availableLanguages ?? []));
  useVerifyCookies(currentLanguage, tenant, availableLanguages);

  // This is for the case that languages changed in some way and the modal is not shown.
  (0, _react.useEffect)(() => {
    if (!modalIsOpen && availableLanguages) {
      setModalIsOpen((0, _utils.getDefaultIsOpenedState)(availableLanguages));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- we don't need to listen to "modalIsOpen"
  }, [availableLanguages]);
  const onCloseCallback = (0, _react.useCallback)(() => {
    setModalIsOpen(false);
  }, []);
  const handleLanguageChange = (0, _react.useCallback)(nextLanguage => {
    UserAction.dispatch([_constants.USER_ACTION_NAME, _constants.USER_ACTION_LOCATION, nextLanguage.code ?? '']);
    (0, _utils.changeLanguage)(nextLanguage, currentLanguage, tenant,
    // If user selected default language then there is no reason to reload the page again
    !(0, _utils.isDefaultLanguage)(nextLanguage));
    onCloseCallback();
  }, [currentLanguage, onCloseCallback, tenant]);
  const configurationProviderValue = (0, _react.useMemo)(() => ({
    ...props,
    languages: availableLanguages
  }), [props, availableLanguages]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "LanguageSwitcherPopup",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ConfigurationProvider, {
        value: configurationProviderValue,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
          team: _testidGenerator.Team.Presentation,
          project: _constantsGenerated.APP_NAME,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LanguageSelectModal, {
            isOpen: modalIsOpen,
            onLanguageChange: handleLanguageChange,
            onClose: onCloseCallback
          })
        })
      })
    })
  });
};
exports.LanguageSwitcherPopup = LanguageSwitcherPopup;
